import axios from "axios";

const BASE_URL = `https://zaminhost.com/api`

export const axiosInstance = () => {
    const headers = {
        'Authorization': `Bearer ${localStorage.getItem("token")}`
    }
    return axios.create({
        baseURL: BASE_URL,
        // baseURL: `http://localhost:8080/api`,
        headers: headers,
    })
}

export const getHomePage = (callBack) => {
    axiosInstance().get(`/get-home-page`)
        .then((res) => {
            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data);
            } else if (res.data.status === 401) {
                window.location.pathname = "/login";
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            if (err.response.status === 401) {
                window.location.pathname = "/login";
            }
            callBack(false, err.msg);
        });
}

export const confirmInfo = (callBack) => {
    axiosInstance().post(`/confirm-profile`)
        .then((res) => {
            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data.msg);
            } else if (res.data.status === 401) {
                window.location.pathname = "/login";
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            if (err.response.status === 401) {
                window.location.pathname = "/login";
            }
            callBack(false, err.msg);
        });
}

export const TicketCategory = (callBack) => {
    axiosInstance().get(`/get-ticket-category`)
        .then((res) => {

            if (res.data.status === 200) {
                callBack(true, res.data);
            } else {
                callBack(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
        });
}
export const postNewTicket = (data, callBack) => {
    axiosInstance().post(`/new-ticket`, data)
        .then((res) => {

            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}
export const postNewTicketDetail = (data, callBack) => {
    axiosInstance().post(`/new-ticket-detail`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then((res) => {

            if (res.data.status === 200) {
                callBack(true, res.data.msg);
            } else {
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}

export const postCloseTicket = (data, callBack) => {
    axiosInstance().post(`/close-ticket`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then((res) => {

            if (res.data.status === 200) {
                callBack(true, res.data.msg);
            } else {
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}

export const getServiceDetail = (id, callBack) => {
    // console.log("id", id)
    axiosInstance().get(`/get-service-detail?service_id=${id}`)
        .then((res) => {
            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data.msg);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}
export const getTrafficService = (item, callBack) => {
    // console.log("id", id)
    axiosInstance().get(`/get-traffic?service_id=${item.id}${item.st ? `&start=${item.st}` : ''}${item.ex ? `&end=${item.ex}` : ''}`)
        .then((res) => {
            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data.msg);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}
export const getTrafficUsage = (item, callBack) => {
    // console.log("id", id)
    axiosInstance().get(`/get-traffic-usage?service_id=${item.id}${item.st ? `&start=${item.st}` : ''}${item.ex ? `&end=${item.ex}` : ''}`)
        .then((res) => {
            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data.msg);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}

export const getServiceMonitor = (id, callBack) => {
    axiosInstance().get(`/get-service-monitor?service_id=${id}`)
        .then((res) => {
            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data.msg);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}

export const getTicketDetail = (id, callBack) => {
    // console.log("id", id)
    axiosInstance().get(`/get-ticket-detail?ticket_id=${id}`)
        .then((res) => {

            if (res.data.status === 200) {
                callBack(true, res.data.ticket_detail);
                // console.log(res.data);
            } else {
                callBack(false, res.data.msg);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}
export const getFactorDetail = (id, callBack) => {
    // console.log("id", id)
    axiosInstance().get(`/get-factor-detail?invoice_no=${id}`)
        .then((res) => {

            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data.factor_info);
            } else {
                callBack(false, res.data.msg);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}
export const changePassPost = (data, callBack) => {
    axiosInstance().post(`/change-password`, data)
        .then((res) => {

            if (res.data.status === 200) {
                callBack(true, res.data.msg);
                // console.log(res.data);
            } else {
                callBack(false, res.data.msg);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}
export const changeAutomaticPayment = (data, callBack) => {
    axiosInstance().post(`/set-auto-pay`, data)
        .then((res) => {

            if (res.data.status === 200) {
                callBack(true, res.data.msg);
                // console.log(res.data);
            } else {
                callBack(false, res.data.msg);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}
export const getVPSIran = (callBack) => {
    axiosInstance().get(`/vps-iran`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data.products);
                callBack(true, res.data.products);
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const getVPSEurope = (callBack) => {
    axiosInstance().get(`/vps-europe`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data.products);
                callBack(true, res.data.products);
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const getUserInfo = (callBack) => {
    axiosInstance().get(`/get-user-info`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data);
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const editInfo = (info, callBack) => {
    axiosInstance().post(`/edit-profile`, info)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data.msg);
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const getCity = (id, callBack) => {
    axiosInstance().get(`/get-city-list?province_id=${id}`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data);
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const getProvince = (callBack) => {
    axiosInstance().get(`/get-province-list`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data);
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const getServiceOrder = (id, callBack) => {
    axiosInstance().get(`/order?product_id=${id}`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data);
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const orderPayment = (info, callBack) => {
    axiosInstance().post(`/order`, info)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(1, res.data);
            } else if (res.data.status === 202) {
                // console.log(res.data);
                callBack(2, res.data);
            } else {
                // console.log(res.data.msg);
                callBack(3, res.data);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const getMobile = (mobile, callBack) => {
    axiosInstance().get(`/check-mobile?mobile=${mobile}`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data);
            } else {
                // console.log(res.data);
                callBack(true, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const checkPass = (data, callBack) => {
    axiosInstance().post(`/login`, data)
        .then((res) => {
            callBack(true, res.data);
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const postDataRegister = (data, callBack) => {
    axiosInstance().post(`/register`, data)
        .then((res) => {
            if (res.data.status === 200) {
                callBack(true, res.data);
            } else {
                callBack(false, res.data);
            }

        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const getFactorList = (callBack) => {
    axiosInstance().get(`/get-factors`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data);
            } else {
                // console.log(res.data);
                callBack(true, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const getServiceList = (callBack) => {
    axiosInstance().get(`/get-services`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data);
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const getTicketList = (callBack) => {
    axiosInstance().get(`/get-tickets`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data);
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const checkForgetPass = (mobile, callBack) => {
    axiosInstance().get(`/forget-password?mobile=${mobile}`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data.msg);
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            console.log(err.msg);
            callBack(false, err.msg);
        });
}
export const checkDiscountCode = (code, id, price, callBack) => {
    axiosInstance().get(`/check-discount-code?code=${code}&service_id=${id}&payment_price=${price}`)
        .then((res) => {

            if (res.data.status === 200) {
                console.log(res.data);
                callBack(true, res.data);
            } else {
                console.log(res.data);
                callBack(false, res.data);
            }
        })
        .catch((err) => {
            console.log(err.msg);
            callBack(false, err.msg);
        });
}

export const getPermissionGroup = (callBack) => {
    axiosInstance().get(`/permission-groups`)
        .then((res) => {

            if (res.data.status === 200) {
                // console.log(res.data);
                callBack(true, res.data);
            } else {
                // console.log(res.data);
                callBack(false, res.data.msg);
            }
        })
        .catch((err) => {
            // console.log(err.msg);
            callBack(false, err.msg);
        });
}

export const postNewPermission = (data, callBack) => {
    axiosInstance().post(`/permission-groups`, data)
        .then((res) => {

            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}

export const updateGroupPermission = (data, callBack) => {
    const options = {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data)
    };

    fetch(`${BASE_URL}/permission-groups`, options)
        .then(response => response.json())
        .then(res => {
            if (res.status === 200) {
                callBack(true, res);
            } else {
                callBack(false, res);
            }
        })
        .catch(err => callBack(false, err.msg));
}

export const deleteGroupPermission = (id, callBack) => {
    axiosInstance().delete(`/permission-groups?group_id=${id}`)
        .then((res) => {
            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}

export const getGroupPermissionMember = (id, callBack) => {
    axiosInstance().get(`/permission-group-members?group_id=${id}`)
        .then((res) => {
            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}

export const postNewPermissionMember = (data, callBack) => {
    axiosInstance().post(`/permission-group-members`, data)
        .then((res) => {

            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}

export const deletePermissionMember = (id, callBack) => {
    axiosInstance().delete(`/permission-group-members?group_member_id=${id}`)
        .then((res) => {
            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}

export const getGroupPermissionService = (id, callBack) => {
    axiosInstance().get(`/permission-group-services?group_id=${id}`)
        .then((res) => {
            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}

export const postNewPermissionService = (data, callBack) => {
    axiosInstance().post(`/permission-group-services`, data)
        .then((res) => {

            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}

export const deletePermissionService = (id, callBack) => {
    axiosInstance().delete(`/permission-group-services?group_service_id=${id}`)
        .then((res) => {
            if (res.data.status === 200) {
                callBack(true, res.data);
                // console.log(res.data);
            } else {
                callBack(false, res.data);
                // console.log(res.data);
            }
        })
        .catch((err) => {
            callBack(false, err.msg);
            // console.log(err.msg);
        });
}
